import ScrollContainer from 'components/page/ScrollContainer'
import { heightOfToolbar } from 'const'
import { ReactNode, useMemo } from 'react'
import { ETimelinePostStatus, ETimelinePostType, ShareTimelineItem } from 'types'
import { TimelineDateItem } from '../../../Timeline/components/TimelineDateItem/TimelineDateItem'
import { TimelineNoteItem } from '../../../Timeline/components/TimelineNoteItem/TimelineNoteItem'
import { SharedCareArticleItem } from '../SharedCareArticleItem/SharedCareArticleItem'
import { SharedCommentControl } from '../SharedCommentControl'
import { SharedLearnArticleItem } from '../SharedLearnArticleItem/SharedLearnArticleItem'
import { SharedLessonItem } from '../SharedLessonItem/SharedLessonItem'

export function SharedTimelineList({ timeline }: { timeline: ShareTimelineItem[] }) {
  const sortedTimeline = useMemo(() => {
    return [...timeline].sort((a, b) => {
      const isDoneA = a.status === ETimelinePostStatus.done
      const isDoneB = b.status === ETimelinePostStatus.done

      if (isDoneA && !isDoneB) return 1
      if (!isDoneA && isDoneB) return -1
      return 0
    })
  }, [timeline])

  const createCommentControl = (item: ShareTimelineItem): ReactNode | undefined => {
    return (
      <SharedCommentControl
        comment={item.comment || ''}
        sharedBy={`${item.sender.firstname} ${item.sender.lastname}`}
        sharedAt={item.createdAt}
      />
    )
  }

  return (
    <ScrollContainer deltaSpace={heightOfToolbar} fixLeft>
      <TimelineDateItem date={new Date().toISOString()} text="Today" />

      {sortedTimeline.map((item) => {
        if (item.type === ETimelinePostType.note && item.note && item.noteId !== null) {
          return (
            <TimelineNoteItem
              key={`${item.type}_${item.id}`}
              timelineId={item.id}
              id={item.noteId}
              title={item.note.subject}
              text={item.note.body}
              link={item.note.link}
              date={item.note.createdAt}
              authorId={item.note.authorId}
              authorName={item.note.authorName}
              status={item.status}
              commentControl={createCommentControl(item)}
              isShared
            />
          )
        }

        if (
          (item.type === ETimelinePostType.careArticle ||
            item.type === ETimelinePostType.taskArticle) &&
          item.careArticle
        ) {
          return (
            <SharedCareArticleItem
              key={`${item.type}_${item.id}`}
              item={item}
              commentControl={createCommentControl(item)}
            />
          )
        }

        if (item.type === ETimelinePostType.lessons) {
          return (
            <SharedLessonItem
              key={`${item.type}_${item.id}`}
              item={item}
              commentControl={createCommentControl(item)}
            />
          )
        }

        if (item.type === ETimelinePostType.learnArticles) {
          return (
            <SharedLearnArticleItem
              key={`${item.type}_${item.id}`}
              item={item}
              commentControl={createCommentControl(item)}
            />
          )
        }

        return null
      })}
    </ScrollContainer>
  )
}
